"use client";

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";

interface ProjectModalProps {
  project: {
    id: number;
    title: string;
    description: string;
    sponsored: boolean;
    sponsor?: string;
    status: string;
  };
  isOpen: boolean;
  onClose: () => void;
}

export default function ProjectModal({ project, isOpen, onClose }: ProjectModalProps) {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-5xl max-h-[90vh] overflow-y-auto" showCloseButton={true}>
        <DialogHeader>
          <div className="flex items-center space-x-4">
            <DialogTitle className="text-2xl font-bold text-gray-900">
              {project.title}
            </DialogTitle>
            <span className={`px-3 py-1 rounded-full text-sm font-medium ${
              project.status === 'ongoing' 
                ? 'bg-green-100 text-green-800' 
                : 'bg-blue-100 text-blue-800'
            }`}>
              {project.status === 'ongoing' ? 'Ongoing' : 'Completed'}
            </span>
          </div>
        </DialogHeader>

        {/* Body */}
        <div className="py-4">
          <div className="grid md:grid-cols-3 gap-6">
            {/* Main Content */}
            <div className="md:col-span-2">
              <h4 className="text-lg font-semibold text-gray-900 mb-4">Project Description</h4>
              <p className="text-gray-700 leading-relaxed mb-6">
                {project.description}
              </p>
            </div>

            {/* Sidebar */}
            <div className="space-y-6">
              {/* Project Info */}
              <div className="bg-gray-50 rounded-lg p-4">
                <h5 className="font-semibold text-gray-900 mb-3">Project Details</h5>
                
                <div className="space-y-3">
                  
                  <div>
                    <span className="text-sm font-medium text-gray-500">Funding:</span>
                    <div className="flex items-center mt-1">
                      <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                        project.sponsored 
                          ? 'bg-orange-100 text-orange-800' 
                          : 'bg-gray-100 text-gray-800'
                      }`}>
                        {project.sponsored ? 'Sponsored' : 'Not Sponsored'}
                      </span>
                    </div>
                  </div>

                  {project.sponsored && project.sponsor && (
                    <div>
                      <span className="text-sm font-medium text-gray-500">Sponsor:</span>
                      <p className="text-sm text-gray-900">{project.sponsor}</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <DialogFooter>
          <button
            onClick={onClose}
            className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary transition-colors duration-200"
          >
            Close
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
